import React from 'react';
import styles from './PrivacyPolicy.module.css';

export default function PrivacyPolicy() {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>PRIVACY POLICY — My AI Agent</h1>
      <p className={styles.lastUpdated}>
        (Not legal advice but written in standard website privacy-policy format. You may have an attorney review before publication.)
      </p>
      <p className={styles.lastUpdated}>Last Updated: January 2025</p>

      <section className={styles.section}>
        <h2 className={styles.heading}>1. Introduction</h2>
        <p>
          My AI Agent ("we," "our," "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, store, and safeguard your information when you use our website, services, and communication tools.
        </p>
        <p>By using myaiagent.biz, you consent to the practices described in this Privacy Policy.</p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.heading}>2. Information We Collect</h2>
        
        <h3 className={styles.subheading}>Information You Provide</h3>
        <ul className={styles.list}>
          <li>Name, email address, phone number</li>
          <li>Business details</li>
          <li>Messages sent through our forms or chat widgets</li>
        </ul>

        <h3 className={styles.subheading}>Automatically Collected Information</h3>
        <ul className={styles.list}>
          <li>IP address</li>
          <li>Browser type</li>
          <li>Device information</li>
          <li>Usage data</li>
          <li>Cookies and analytics data</li>
        </ul>

        <h3 className={styles.subheading}>Communication Data</h3>
        <p>If you use our missed call text-back or AI communication services:</p>
        <ul className={styles.list}>
          <li>Call metadata (not call audio)</li>
          <li>SMS records</li>
          <li>Conversation transcripts</li>
          <li>Automation data flows</li>
        </ul>
        <p>We only collect data necessary to operate and improve the service.</p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.heading}>3. How We Use Your Information</h2>
        <ul className={styles.list}>
          <li>To provide missed call text-back and AI automation services</li>
          <li>To improve the performance of our system</li>
          <li>To respond to support requests</li>
          <li>To analyze usage and enhance user experience</li>
          <li>To send service-related updates</li>
          <li>For security, monitoring, and fraud prevention</li>
        </ul>
        <p className={styles.highlight}>We do not sell your personal information.</p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.heading}>4. Data Sharing</h2>
        <p>We may share limited data with:</p>
        <ul className={styles.list}>
          <li>Service providers (e.g., Telnyx, SMS gateways)</li>
          <li>CRM or automation tools you choose to integrate</li>
          <li>Cloud hosting platforms</li>
          <li>Analytics providers</li>
        </ul>
        <p className={styles.highlight}>We never share data with third parties for marketing or advertising.</p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.heading}>5. Data Security</h2>
        <p>We implement appropriate security measures including:</p>
        <ul className={styles.list}>
          <li>Encryption in transit</li>
          <li>Secure data storage</li>
          <li>Access control</li>
          <li>Logging and monitoring</li>
          <li>Regular audits</li>
        </ul>
        <p>However, no method of transmission over the internet is 100% secure.</p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.heading}>6. Your Rights</h2>
        <p>Depending on your location, you may have the right to:</p>
        <ul className={styles.list}>
          <li>Access your data</li>
          <li>Correct inaccuracies</li>
          <li>Request deletion</li>
          <li>Opt out of communications</li>
          <li>Limit processing</li>
        </ul>
        <p>
          To submit a request, contact:{' '}
          <a href="mailto:myaiagentbiz@gmail.com" className={styles.link}>
            myaiagentbiz@gmail.com
          </a>
        </p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.heading}>7. Data Retention</h2>
        <p>We retain data only as long as needed to deliver services or comply with legal requirements.</p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.heading}>8. Children's Privacy</h2>
        <p>Our service is not intended for anyone under the age of 13.</p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.heading}>9. Changes to This Policy</h2>
        <p>We may update this Privacy Policy. Updates will be posted with a new "Last Updated" date.</p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.heading}>10. Contact Us</h2>
        <div className={styles.contactInfo}>
          <p>
            <strong>Email:</strong>{' '}
            <a href="mailto:myaiagentbiz@gmail.com" className={styles.link}>
              myaiagentbiz@gmail.com
            </a>
          </p>
          <p>
            <strong>Website:</strong>{' '}
            <a href="https://myaiagent.biz" target="_blank" rel="noopener noreferrer" className={styles.link}>
              myaiagent.biz
            </a>
          </p>
        </div>
      </section>
    </div>
  );
}